import React, { useState } from 'react'
import { useBlockEffect } from '@smartfire/js-block-engine'
import { Swiper as SwiperType } from 'swiper/types'
import style from './style.module.scss'
import clsx from 'clsx'

export const CommonSliderNavigation: React.FC<{ swiper?: SwiperType }> = ({ swiper }) => {
    const [greyed, setGreyed] = useState(-1)

    const swipe = (next: number) => {
        if (next === 1) swiper?.slideNext(400)
        else swiper?.slidePrev(400)
    }

    const handleOnSlideChange = (s: SwiperType) => {
        if (s.isBeginning) setGreyed(-1)
        else if (s.isEnd) setGreyed(1)
        else setGreyed(0)
    }

    useBlockEffect(() => {
        swiper?.on('slideChange', handleOnSlideChange)
        return () => swiper?.off('slideChange', handleOnSlideChange)
    }, [swiper])

    return (
        <div className={style.navigation}>
            <i
                className={clsx('fi fi-rs-angle-small-left', greyed === -1 && style.greyed)}
                onClick={() => swipe(-1)}
            ></i>
            <i
                className={clsx('fi fi-rs-angle-small-right', greyed === 1 && style.greyed)}
                onClick={() => swipe(1)}
            ></i>
        </div>
    )
}
